import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import Section from './Section';
import styles from './Faq.scss';

export default class Faq extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: 0, cards: [1, 2, 3] };
  }

  toggle(e) {
    let event = e.currentTarget.dataset.event;
    this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
  }

  questions = [
    {
      question: 'How will I know my event is getting noticed before the event date?',
      answer: 'Your promoted events have a report page updated for you every day that will track ' +
        'clicks and referring domains.'
    },
    {
      question: 'Can my event be sent through a targeted email campaign?',
      answer: 'Once your event is submitted (free or premium) you will have an option to send an email' +
        ' blast to a targeted audience based on your specific category and location.'
    },
    {
      question: 'My event is a niche event, how will it get noticed?',
      answer: 'The category you choose will make an immediate impact on how your event gets noticed.' +
        ' We syndicate your event to sites based on the chosen category.'
    }
  ]

  render() {
    const {cards, collapse} = this.state;
    return (
      <Section title="Frequently asked questions" sectionClass={styles.faq} id="faq-section" 
        subtitle={<span>We're here to help. If you run into any problems at all, feel free to <br/>
          <a className="bolder" href="https://sales.evvnt.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer"> contact us</a> and we'd love to talk personally about how we can help.</span>}>
        {cards.map(index => {
          return (
            <div className="question" key={index}>
              <a className="collapsible-header" onClick={this.toggle} data-event={index}>
                <span>{this.questions[index-1].question}</span>
                {collapse === index ? <i className="fa fa-minus"/>: <i className="fa fa-plus"/>}
              </a>
              <Collapse isOpen={collapse === index}>
                <div className="collapsible-content">
                  <span>{this.questions[index-1].answer}</span>
                </div>
              </Collapse>
            </div>
          );
        })}
      </Section>
    );
  }
}




// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/Faq.jsx